const config = {
    api: 'https://strapi.zstbynp.cz'
}

export default config;
